export const DATA_LIMIT = 40;
export const SAVE_BLOG_POST_TIME_DELAY = 2000;

export const BLOG_POST_FIELDS_LIST = [
    {attribute: "category", label: "Category", cssClass: 'text-center'},
    {attribute: "title", label: "Title"},
    {attribute: "status", label: "Status", cssClass: 'text-center'},
];

export const BLOG_POST_STATUS_LIST = [
    {key: 'New', label: 'New'},
    {key: 'Draft', label: 'Draft'},
    {key: 'Ready', label: 'Ready'},
    {key: 'Published', label: 'Published'},
];

export const MULTIPLE_BLOG_POST_INPUT_FIELDS = [
    {attribute: "category", label: "Category", type: 'text', readOnly: false, group: 'blog'},
    {attribute: "titles", label: "Titles", type: 'text-area', readOnly: false, group: 'blog'},
    {
        attribute: "status",
        label: "Status",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: BLOG_POST_STATUS_LIST,
        default: 'New'
    },
];

export const BLOG_POST_INPUT_FIELDS = [
    {attribute: "category", label: "Category", type: 'text', readOnly: false, group: 'blog'},
    {attribute: "title", label: "Title", type: 'text-area', readOnly: false, group: 'blog'},
    {
        attribute: "status",
        label: "Status",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: BLOG_POST_STATUS_LIST,
        default: 'New'
    },
];

export const BLOG_POST_FILTER_CATEGORY = {
    attribute: "category",
    label: "Category",
    type: 'select',
    readOnly: false,
    group: 'filter',
    options: [],
    default: ''
};

export const BLOG_POST_FILTER_FIELDS = [
    {
        attribute: "status",
        label: "Status",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: BLOG_POST_STATUS_LIST,
        default: ''
    }
];

export const TONES_LIST = [
    {key: "Authoritative", label: "Authoritative"},
    {key: "Catchy", label: "Catchy"},
    {key: "Caring", label: "Caring"},
    {key: "Cheerful", label: "Cheerful"},
    {key: "Coarse", label: "Coarse"},
    {key: "Conservative", label: "Conservative"},
    {key: "Conversational", label: "Conversational"},
    {key: "Casual", label: "Casual"},
    {key: "Dry", label: "Dry"},
    {key: "Edgy", label: "Edgy"},
    {key: "Enthusiastic", label: "Enthusiastic"},
    {key: "Formal", label: "Formal"},
    {key: "Frank", label: "Frank"},
    {key: "Friendly", label: "Friendly"},
    {key: "Fun", label: "Fun"},
    {key: "Funny", label: "Funny"},
    {key: "Humorous", label: "Humorous"},
    {key: "Informative", label: "Informative"},
    {key: "Irreverent", label: "Irreverent"},
    {key: "Matter-of-fact", label: "Matter-of-fact"},
    {key: "Nostalgic", label: "Nostalgic"},
    {key: "Passionate", label: "Passionate"},
    {key: "Playful", label: "Playful"},
    {key: "Professional", label: "Professional"},
    {key: "Provocative", label: "Provocative"},
    {key: "Quirky", label: "Quirky"},
    {key: "Respectful", label: "Respectful"},
    {key: "Romantic", label: "Romantic"},
    {key: "Sarcastic", label: "Sarcastic"},
    {key: "Serious", label: "Serious"},
    {key: "Smart", label: "Smart"},
    {key: "Snarky", label: "Snarky"},
    {key: "Sympathetic", label: "Sympathetic"},
    {key: "Trendy", label: "Trendy"},
    {key: "Trustworthy", label: "Trustworthy"},
    {key: "Unapologetic", label: "Unapologetic"},
    {key: "Upbeat", label: "Upbeat"},
    {key: "Witty", label: "Witty"}
];
